import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster/angular2-toaster';


@Component({
    selector: 'forgot-password',
    templateUrl: 'forgot-password.template.html',
})
export class ForgotPasswordComponent {
    year = new Date().getFullYear();
    forgotPasswordForm: FormGroup;

    constructor(private fb: FormBuilder,
                private http: Http,
                private toasterService: ToasterService,
                private router: Router) {

    }

    ngOnInit(): void {
        this.createForm();
    }

    createForm() {
        //noinspection TypeScriptValidateTypes
        this.forgotPasswordForm = this.fb.group({
            email: new FormControl('', Validators.compose([
                Validators.required,
                CustomValidators.email
            ])),
        });
    }

    submit(model, isValid: boolean) {
        if (!isValid) {
            return false;
        }
        this.forgotPasswordForm.disable();
        this.http.post('/passwords/forgot', model)
            .map(r => r.json())
            .finally(() => {
                this.forgotPasswordForm.enable();
            })
            .subscribe((response) => {
                this.toasterService.pop('success', 'Success', response.data)
                this.router.navigate(['/login'])
            })

    }
}




// WEBPACK FOOTER //
// ./src/app/views/forgot-password/forgot-password.component.ts